
export function defaultOrdering(item1, item2) {
  const name1 = (item1.name || item1.primaryText || '').toLowerCase();
  const name2 = (item2.name || item2.primaryText || '').toLowerCase();

  if (name1.startsWith('other')) {
    return 1;
  }

  if (name2.startsWith('other')) {
    return -1;
  }

  if (name1.startsWith('none')) {
    return -1;
  }

  if (name2.startsWith('none')) {
    return 1;
  }

  if (name1 > name2) {
    return 1;
  }

  if (name2 > name1) {
    return -1;
  }

  return 0;
}

export function YesNoItems() {
  return [
    {
      value: true,
      primaryText: 'Yes'},
    {
      value: false,
      primaryText: 'No'
    }
  ];
}



// WEBPACK FOOTER //
// ./shared/lib/dropdowns.js